// extracted by mini-css-extract-plugin
export default {"heading":"IdleStage_heading__VCM5J","input":"IdleStage_input__GrYpr","button":"IdleStage_button__9cpUl"};